import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {Injectable} from "@angular/core";
import {TreatmentJourneyDefinitionModel} from "./treatmentJourneyDefinition.model";
import {TreatmentJourneyDefinitionSummaryConverter} from "./treatmentJourneyDefinitionSummary.converter";
import {
    TreatmentJourneyStepDefinitionConverter
} from "../../../step/api/entity/treatmentJourneyStepDefinition.converter";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyDefinitionConverter extends HttpModelConverter<TreatmentJourneyDefinitionModel> {

    constructor(private stepDefinitionConverter: TreatmentJourneyStepDefinitionConverter,
                private summaryConverter: TreatmentJourneyDefinitionSummaryConverter) {
        super();
    }

    protected createInstance(): TreatmentJourneyDefinitionModel {
        return new TreatmentJourneyDefinitionModel();
    }

    protected enrichObject(result: TreatmentJourneyDefinitionModel, src: TreatmentJourneyDefinitionModel) {
        result.stepDefinitions = this.stepDefinitionConverter.convertFromArray(src.stepDefinitions);
        result.summary = this.summaryConverter.convert(src.summary);
    }


}